import MuiTextField from '@material-ui/core/TextField';
import MuiSwitch from '@material-ui/core/Switch';
import MuiCheckbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MuiSelect from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import FormHelperText from '@material-ui/core/FormHelperText';
import MuiRadioGroup from '@material-ui/core/RadioGroup';
import { createElement, useCallback } from 'react';
import MuiInputBase from '@material-ui/core/InputBase';
import { useField, useFormikContext } from 'formik';
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
}

var useFieldToTextField = function useFieldToTextField(_a) {
  var _b;

  var disabled = _a.disabled,
      name = _a.name,
      props = __rest(_a, ["disabled", "name"]);

  var isSubmitting = useFormikContext().isSubmitting;

  var _c = useField(name),
      field = _c[0],
      meta = _c[1];

  var fieldError = meta.error;
  var showError = meta.touched && !!fieldError;
  return _assign(_assign(_assign({}, props), field), {
    error: showError,
    helperText: showError ? fieldError : props.helperText,
    disabled: disabled !== null && disabled !== void 0 ? disabled : isSubmitting,
    variant: (_b = props.variant, _b !== null && _b !== void 0 ? _b : 'standard')
  });
};

var TextField = function TextField(_a) {
  var children = _a.children,
      props = __rest(_a, ["children"]);

  return createElement(MuiTextField, _assign({}, useFieldToTextField(props)), children);
};

TextField.displayName = 'FormikMaterialUITextField';

var useFieldToSwitch = function useFieldToSwitch(_a) {
  var disabled = _a.disabled,
      name = _a.name,
      props = __rest(_a, ["disabled", "name"]);

  var isSubmitting = useFormikContext().isSubmitting;
  var field = useField(name)[0];
  return _assign(_assign(_assign({
    disabled: disabled !== null && disabled !== void 0 ? disabled : isSubmitting
  }, props), field), {
    value: field.name,
    checked: field.value
  });
};

var Switch = function Switch(props) {
  return createElement(MuiSwitch, _assign({}, useFieldToSwitch(props)));
};

Switch.displayName = 'FormikMaterialUISwitch';

var useFieldToCheckbox = function useFieldToCheckbox(_a) {
  var disabled = _a.disabled,
      name = _a.name,
      props = __rest(_a, ["disabled", "name"]);

  var isSubmitting = useFormikContext().isSubmitting;
  var field = useField(name)[0];
  return _assign(_assign(_assign({
    disabled: disabled !== null && disabled !== void 0 ? disabled : isSubmitting
  }, props), field), {
    checked: field.value,
    value: field.value ? 'checked' : ''
  });
};

var Checkbox = function Checkbox(props) {
  return createElement(MuiCheckbox, _assign({}, useFieldToCheckbox(props)));
};

Checkbox.displayName = 'FormikMaterialUICheckbox';

var CheckboxWithLabel = function CheckboxWithLabel(_a) {
  var Label = _a.Label,
      props = __rest(_a, ["Label"]);

  return createElement(FormControlLabel, _assign({
    control: createElement(MuiCheckbox, _assign({}, useFieldToCheckbox(props)))
  }, Label));
};

CheckboxWithLabel.displayName = 'FormikMaterialUICheckboxWithLabel';

var useFieldToSelect = function useFieldToSelect(_a) {
  var disabled = _a.disabled,
      name = _a.name,
      props = __rest(_a, ["disabled", "name"]);

  var isSubmitting = useFormikContext().isSubmitting;

  var _b = useField(name),
      field = _b[0],
      helpers = _b[2];

  var onChange = useCallback(function (event) {
    if (props.multiple && props.native) {
      var options = event.target.options;
      var value = [];

      for (var i = 0, l = options.length; i < l; i += 1) {
        if (options[i].selected) {
          value.push(options[i].value);
        }
      }

      helpers.setValue(value);
    } else {
      field.onChange(event);
    }
  }, [field.name, props.multiple, props.native]);
  return _assign(_assign(_assign({
    disabled: disabled !== null && disabled !== void 0 ? disabled : isSubmitting
  }, props), field), {
    onChange: onChange
  });
};

var Select = function Select(props) {
  return createElement(MuiSelect, _assign({}, useFieldToSelect(props)));
};

Select.displayName = 'FormikMaterialUISelect';

var SimpleFileUpload = function SimpleFileUpload(_a) {
  var name = _a.name,
      label = _a.label,
      _b = _a.disabled,
      disabled = _b === void 0 ? false : _b,
      inputProps = _a.InputProps,
      inputLabelProps = _a.InputLabelProps;
  var isSubmitting = useFormikContext().isSubmitting;

  var _c = useField(name),
      field = _c[0],
      meta = _c[1],
      helpers = _c[2];

  var error = meta.touched && meta.error;
  return createElement("div", null, createElement(FormControl, null, label && createElement(InputLabel, _assign({
    shrink: true,
    error: !!error
  }, inputLabelProps), label), createElement(Input, _assign({
    error: !!error,
    inputProps: {
      type: 'file',
      disabled: disabled || isSubmitting,
      name: field.name,
      onChange: function onChange(event) {
        var file = event.currentTarget.files[0];
        helpers.setValue(file);
      }
    }
  }, inputProps)), error && createElement(FormHelperText, {
    error: true
  }, error)));
};

var useFieldToRadioGroup = function useFieldToRadioGroup(_a) {
  var name = _a.name,
      props = __rest(_a, ["name"]);

  var field = useField(name)[0];
  return _assign(_assign({}, props), field);
};

var RadioGroup = function RadioGroup(props) {
  return createElement(MuiRadioGroup, _assign({}, useFieldToRadioGroup(props)));
};

RadioGroup.displayName = 'FormikMaterialUIRadioGroup';

var useFieldToInputBase = function useFieldToInputBase(_a) {
  var disabled = _a.disabled,
      name = _a.name,
      props = __rest(_a, ["disabled", "name"]);

  var isSubmitting = useFormikContext().isSubmitting;
  var field = useField(name)[0];
  return _assign(_assign({
    disabled: disabled !== null && disabled !== void 0 ? disabled : isSubmitting
  }, props), field);
};

var InputBase = function InputBase(props) {
  return createElement(MuiInputBase, _assign({}, useFieldToInputBase(props)));
};

InputBase.displayName = 'FormikMaterialUIInputBase';
export { useFieldToTextField, TextField, useFieldToSwitch, Switch, useFieldToCheckbox, Checkbox, CheckboxWithLabel, useFieldToSelect, Select, SimpleFileUpload, useFieldToRadioGroup, RadioGroup, useFieldToInputBase, InputBase };